export const T = {
  en: {
    nav: {
      about: "About", meditations: "Meditations", journey: "Journey",
      gallery: "Gallery", testimonials: "Testimonials", contact: "Contact",
      invite: "Invite Maa Prem Mahima",
    },
    hero: {
      eyebrow: "Osho Disciple · Certified Meditation Teacher · Co-Founder, Osho Universal",
      lines: ["Silence is not", "the absence of sound —", "it is the presence", "of you."],
      sub: "Maa Prem Mahima invites you inward — through Osho's active meditations, satsang, and the simple art of being utterly, deliciously present.",
      ctaExplore: "Explore Meditations",
      ctaInvite: "Invite For A Retreat",
      badge: "Certified Osho Facilitator",
      breath: ["Inhale", "Hold", "Exhale", "Rest"],
    },
    marquee: [
      "Osho Dynamic Meditation", "Kundalini Awakening", "Chakra Balancing", "Sound Healing",
      "Breathwork Journeys", "No-Mind Practice", "Silent Retreats", "Heart Satsang",
    ],
    about: {
      eyebrow: "About · The Manifesto",
      h1: "A fellow traveler,",
      h2: "not a master.",
      quote: "\"Join me… not just as a follower, but as a fellow traveler on this beautiful path inward.\"",
      imgAlt: "Maa Prem Mahima in quiet presence",
      chapters: [
        {
          n: "01", title: "The Thirst & The Meeting",
          body: "Maa Prem Mahima did not come to meditation to escape life — she came because something within her longed to slow down, to understand, to feel truly alive. In Osho's words and meditations she found not a doctrine, but a mirror: a way back to herself.",
        },
        {
          n: "02", title: "Silence Beyond Techniques",
          body: "Through Osho's active meditations — the shaking, the catharsis, the dance — she discovered that silence is not manufactured. It arrives on its own when the body has expressed everything it was holding. This is the peace she now shares: one that words cannot fully express.",
        },
        {
          n: "03", title: "Co-Founding Osho Universal",
          body: "As co-founder of Osho Universal, Maa Prem Mahima holds space for seekers across the world — retreats, satsangs, and one-on-one guidance. She does not ask you to follow. She invites you to walk beside her, as a fellow traveler on this beautiful path inward.",
        },
      ],
    },
    yatra: {
      eyebrow: "The Yatra · A Pilgrimage",
      h1: "Five pins on the map",
      h2: "of one awakening",
      intro: "Maa Prem Mahima walked the trail of Osho's childhood — from his birthplace in Kuchwada to the tree under which he disappeared into existence. Each stop left a mark.",
      stopLabel: "STOP",
      stops: [
        {
          title: "Kuchwada — Where He Arrived",
          body: "A village so small the world nearly forgot it — yet this is where Rajneesh Chandra Mohan took his first breath. Walking its narrow lanes, Maa Prem Mahima felt how the vast can hide inside the utterly ordinary.",
        },
        {
          title: "The Childhood Home",
          body: "Behind this rose-pink doorway, a boy once questioned everything he was told. Standing at his threshold, the teaching becomes simple: awakening is not found elsewhere — it begins in your own first home, your own first questions.",
        },
        {
          title: "The Classroom",
          body: "Wooden benches, barred windows, chalk dust in the light. Here the young Osho read relentlessly and argued with every teacher. Sitting at his desk, Maa Prem Mahima sat with the student before the master — the stubborn, luminous questioning that never left him.",
        },
        {
          title: "The School in Gadarwara",
          body: "Years of discipline, mischief, and brilliance unfolded within these yellow walls. A reminder that even the greatest rebellion is educated somewhere — and that every institution once held a child it could not contain.",
        },
        {
          title: "The Moulshree Tree",
          body: "21 March 1953. Beneath this tree, the twenty-one-year-old became what he always was. Maa Prem Mahima embraced its trunk the way one greets an old friend — because for every seeker, this is not history. It is an invitation.",
        },
      ],
      close1: "\"The journey was never about the places.",
      close2: " The places were pointing home.\"",
    },
    gallery: {
      eyebrow: "Glimpses",
      h1: "The path, ",
      h2: "in frames",
      intro: "A yatra through the places that shaped Osho — his birthplace in Kuchwada, his school in Gadarwara, and the Moulshree tree where he awoke.",
      captions: [
        "In the Master's presence",
        "Osho Kaksh — his childhood study room",
        "Under the Moulshree tree, where Osho was enlightened",
        "Satsang across distances",
        "The streets of Kuchwada — Osho's birthplace",
        "At the doorway of Osho's childhood home",
        "In his classroom, where it all began",
        "His school in Gadarwara — the Osho Smart Class",
        "Embracing the OSHO tree",
      ],
    },
    offerings: {
      eyebrow: "Meditations & Sessions",
      h1: "Practices for the",
      h2: " modern, restless mind",
      filterTag: "All offerings · In-person & online",
      cards: [
        { id: "dynamic", title: "Osho Dynamic Meditation", tag: "60 min · Morning",
          desc: "Five stages from catharsis to stillness — breath, expression, the mantra 'Hoo', silence, and celebration. The great unburdening." },
        { id: "kundalini", title: "Osho Kundalini Meditation", tag: "60 min · Sunset",
          desc: "Shaking loose the day, dancing into bliss, then resting in witness. Best practiced as the sun goes down." },
        { id: "chakra", title: "Chakra Energy Balancing", tag: "75 min · In-person & Online",
          desc: "A guided journey through the seven energy centres — sensing, softening, and re-aligning the subtle body." },
        { id: "sound", title: "Sound Healing Journeys", tag: "60 min · Group & Private",
          desc: "Singing bowls, gongs and voice — vibration that loosens what words cannot reach, inviting deep rest." },
        { id: "breathwork", title: "Breathwork Sessions", tag: "60 min · All Levels",
          desc: "Conscious connected breathing to release held emotion and return to the body's natural aliveness." },
        { id: "whiterobe", title: "Evening Satsang & White Robe", tag: "Evening · Gathering",
          desc: "Music, Osho discourse, and shared silence — the heart of the commune, open to every sincere seeker." },
        { id: "nomind", title: "No-Mind & Gibberish", tag: "7-Day Intensive",
          desc: "Osho's meditative therapy: say everything meaningless, until only meaning remains. Profoundly simple, simply profound." },
        { id: "guidance", title: "1-on-1 Inner Guidance", tag: "Private · Online",
          desc: "Personal sessions with Maa Prem Mahima — gentle inquiry, meditation prescription, and space for whatever is arising in you." },
      ],
    },
    stillness: {
      eyebrow: "A Taste Of The Work",
      h1: "One minute of ",
      h2: "centering",
      sub: "Before you read another word — sit with Maa Prem Mahima's simplest instruction. Sixty seconds. Just breath, and the gap between breaths.",
      phases: ["Breathe In", "Hold, gently", "Release", "Rest in the gap"],
      ready: "Ready?",
      welcomeBack: "Welcome back.",
      silenceNote: "The silence was always here",
      seconds: "60 seconds",
      remain: "{n}s remain",
      begin: "Begin One Minute",
      breathing: "Breathing…",
      sitAgain: "Sit Again",
    },
    testimonials: {
      eyebrow: "Seekers' Reflections",
      h1: "What remains ",
      h2: "after the sitting",
      shareCta: "Share Your Reflection",
      formTitle: "Your words may light another's path",
      namePh: "Your name (e.g. A. Malik)",
      rolePh: "Your role (optional)",
      textPh: "What shifted for you in the meditation…",
      submitReflection: "Send Reflection",
      reflectionSuccess: "Thank you — your reflection will appear here once Maa Prem Mahima approves it.",
      reflectionError: "Could not send right now — please try again later.",
      quotes: [
        { text: "After Osho Kundalini meditation my deep sleep became double in quantity, and the quality of my sleep improved. I measured it with my gadget that tracks my sleep.", name: "A. Malik", role: "Meditation Participant" },
        { text: "Changed my life forever by explaining the meaning of one word — Awareness.", name: "L. Gunasinge", role: "Meditation Participant" },
        { text: "Actually stopped thinking for a little bit. Just after one hour of meditation.", name: "J. Shih", role: "Lawyer · Session Participant" },
        { text: "I never thought someone's mind can be without thoughts — today I felt it.", name: "H. Panjavani", role: "Meditation Participant" },
      ],
    },
    contact: {
      eyebrow: "Invite · Connect",
      h1: "Bring this silence",
      h2: "to your people",
      sub: "Maa Prem Mahima is available for retreat facilitation, festival sessions, corporate mindfulness, and private online sittings. Every inquiry is read personally.",
      invites: [
        { title: "Wellness Retreats & Festivals", desc: "Facilitating Osho meditations and satsang gatherings worldwide." },
        { title: "Corporate Mindfulness", desc: "Active meditation programs for teams carrying the modern load." },
        { title: "Online Private Sessions", desc: "One-on-one guidance, wherever you are on the path." },
      ],
      labels: { name: "Full Name", email: "Email", phone: "Phone", eventDate: "Event Date", address: "Full Address", type: "Inquiry Type", location: "City / Country", message: "Message" },
      ph: { name: "Your name", email: "you@email.com", phone: "e.g. +91 98XXX XXXXX", address: "Venue, street, city, country…", location: "Where are you?", message: "Tell us about your gathering, retreat, or what is stirring in you…" },
      types: ["Retreat Facilitation", "Online 1-on-1 Session", "Chakra Balancing", "Sound Healing Session", "Breathwork Session", "Corporate Workshop", "Press / Interview"],
      submit: "Send Sacred Inquiry",
      sending: "Sending…",
      success: "Your inquiry has been received. Maa Prem Mahima's desk will write back soon.",
      error: "Could not send right now — please email mahima.ca1@gmail.com",
      phoneLabel: "Phone",
    },
    footer: {
      quote: "\"If somewhere within you there is a longing to slow down, to understand yourself, to feel a little more alive and peaceful… then this space is for you.\"",
    },
    events: {
      navLabel: "Events",
      eyebrow: "Upcoming Gatherings",
      h1: "Where to ",
      h2: "find her next",
      sub: "Retreats, satsangs and sessions — join in person or online.",
      empty: "New gatherings will be announced soon. Stay close.",
      types: { Retreat: "Retreat", Satsang: "Satsang", Workshop: "Workshop", Online: "Online Session" },
      join: "Join / Register",
    },
  },

  hi: {
    nav: {
      about: "परिचय", meditations: "ध्यान", journey: "यात्रा",
      gallery: "गैलरी", testimonials: "अनुभव", contact: "संपर्क",
      invite: "मा प्रेम महिमा को आमंत्रित करें",
    },
    hero: {
      eyebrow: "ओशो शिष्या · प्रमाणित ध्यान शिक्षिका · सह-संस्थापक, ओशो यूनिवर्सल",
      lines: ["मौन केवल", "ध्वनि का अभाव नहीं —", "यह तो उपस्थिति है", "आपकी।"],
      sub: "मा प्रेम महिमा आपको भीतर आमंत्रित करती हैं — ओशो के सक्रिय ध्यानों, सत्संग और पूर्णतः उपस्थित रहने की सरल कला के माध्यम से।",
      ctaExplore: "ध्यान खोजें",
      ctaInvite: "रिट्रीट हेतु आमंत्रित करें",
      badge: "प्रमाणित ओशो फैसिलिटेटर",
      breath: ["श्वास अंदर", "रोकें", "श्वास बाहर", "विश्राम"],
    },
    marquee: [
      "ओशो डायनमिक ध्यान", "कुण्डलिनी जागरण", "चक्र संतुलन", "नाद उपचार",
      "श्वास यात्राएँ", "नो-माइंड साधना", "मौन शिविर", "हृदय सत्संग",
    ],
    about: {
      eyebrow: "परिचय · घोषणा",
      h1: "एक साथी यात्री,",
      h2: "मास्टर नहीं।",
      quote: "\"मेरे साथ चलिए… अनुयायी के रूप में नहीं, बल्कि इस सुंदर आंतरिक मार्ग पर एक साथी यात्री के रूप में।\"",
      imgAlt: "मा प्रेम महिमा — शांत उपस्थिति में",
      chapters: [
        {
          n: "01", title: "प्यास और मिलन",
          body: "मा प्रेम महिमा जीवन से भागने के लिए ध्यान में नहीं आईं — वे इसलिए आईं क्योंकि भीतर कुछ धीमा होने, समझने, सचमुच जीवंत महसूस करने की ललक थी। ओशो के शब्दों और ध्यानों में उन्हें कोई सिद्धांत नहीं, एक दर्पण मिला: स्वयं तक लौटने का मार्ग।",
        },
        {
          n: "02", title: "तकनीकों के परे मौन",
          body: "ओशो के सक्रिय ध्यानों — कंपन, भाव-विसर्जन, नृत्य — के माध्यम से उन्होंने जाना कि मौन बनाया नहीं जाता। जब शरीर अपना संचित सब व्यक्त कर देता है, मौन स्वयं उतर आता है। यही वह शांति है जो वे अब बाँटती हैं — जिसे शब्द पूरी तरह कह नहीं पाते।",
        },
        {
          n: "03", title: "ओशो यूनिवर्सल की सह-स्थापना",
          body: "ओशो यूनिवर्सल की सह-संस्थापक के रूप में, मा प्रेम महिमा विश्वभर के साधकों के लिए आकाश धारण करती हैं — शिविर, सत्संग और एकांत मार्गदर्शन। वे आपसे अनुसरण नहीं माँगतीं। वे इस सुंदर आंतरिक मार्ग पर साथी यात्री बनकर साथ चलने का आमंत्रण देती हैं।",
        },
      ],
    },
    yatra: {
      eyebrow: "यात्रा · एक तीर्थ",
      h1: "नक्शे पर पाँच निशान",
      h2: "एक ही जागरण के",
      intro: "मा प्रेम महिमा ओशो के बचपन के पथ पर चलीं — कुचवाड़ा में उनके जन्मस्थान से लेकर उस वृक्ष तक जिसके नीचे वे अस्तित्व में विलीन हो गए। हर पड़ाव ने अपनी छाप छोड़ी।",
      stopLabel: "पड़ाव",
      stops: [
        {
          title: "कुचवाड़ा — जहाँ उनका आगमन हुआ",
          body: "इतना छोटा गाँव कि दुनिया उसे लगभग भूल गई — फिर भी यहीं राजनीश चंद्र मोहन ने पहली साँस ली। इन संकरी गलियों में चलते हुए मा प्रेम महिमा ने महसूस किया कि विशाल कैसे साधारण में छिपा होता है।",
        },
        {
          title: "बचपन का घर",
          body: "इस गुलाबी द्वार के पीछे, एक बालक ने सुनाई गई हर बात पर सवाल उठाया। उसकी देहली पर खड़े होकर शिक्षा सरल हो जाती है: जागरण कहीं और नहीं मिलता — वह आपके अपने पहले घर, आपके अपने पहले प्रश्नों से शुरू होता है।",
        },
        {
          title: "कक्षा",
          body: "लकड़ी के बेंच, जाँघियों वाली खिड़कियाँ, रोशनी में चॉक की धूल। यहीं युवा ओशो ने अथक पढ़ाई की और हर शिक्षक से तर्क किया। उनकी डेस्क पर बैठकर, मा प्रेम महिमा उस विद्यार्थी के साथ बैठीं जो मास्टर से पहले था — वह जिद्दी, दीप्तिमान जिज्ञासा जो कभी नहीं छूटी।",
        },
        {
          title: "गाडरवारा का विद्यालय",
          body: "इन पीली दीवारों के भीतर अनुशासन, शरारत और प्रतिभा के वर्ष बिते। यह स्मरण दिलाता है कि सबसे बड़े विद्रोह की पढ़ाई भी कहीं होती है — और हर संस्था ने कभी न कभी ऐसे बच्चे को संभाला है जिसे वह रोक नहीं सकी।",
        },
        {
          title: "मौलश्री वृक्ष",
          body: "21 मार्च 1953। इसी वृक्ष के नीचे, इक्कीस वर्षीय युवक वह बन गया जो वह सदा से था। मा प्रेम महिमा ने इसके तने को ऐसे भेंटा जैसे पुराने मित्र से मिलती हैं — क्योंकि हर साधक के लिए यह इतिहास नहीं, एक निमंत्रण है।",
        },
      ],
      close1: "\"यात्रा कभी स्थानों की नहीं थी।",
      close2: " स्थान तो बस घर की ओर इशारा कर रहे थे।\"",
    },
    gallery: {
      eyebrow: "झलकियाँ",
      h1: "पथ, ",
      h2: "फ्रेमों में",
      intro: "ओशो को घड़ने वाले स्थानों की यात्रा — कुचवाड़ा में जन्मस्थान, गाडरवारा में विद्यालय, और मौलश्री वृक्ष जहाँ वे जागे।",
      captions: [
        "मास्टर की उपस्थिति में",
        "ओशो कक्ष — उनका बचपन का अध्ययन कक्ष",
        "मौलश्री वृक्ष तले, जहाँ ओशो प्रबुद्ध हुए",
        "दूरियों के पार सत्संग",
        "कुचवाड़ा की गलियाँ — ओशो का जन्मस्थान",
        "ओशो के बचपन के घर के द्वार पर",
        "उनकी कक्षा में, जहाँ से सब शुरू हुआ",
        "गाडरवारा का विद्यालय — ओशो स्मार्ट क्लास",
        "ओशो वृक्ष को आलिंगन",
      ],
    },
    offerings: {
      eyebrow: "ध्यान और सत्र",
      h1: "आधुनिक, बेचैन मन",
      h2: " के लिए साधनाएँ",
      filterTag: "सभी सत्र · व्यक्तिगत व ऑनलाइन",
      cards: [
        { id: "dynamic", title: "ओशो डायनमिक ध्यान", tag: "60 मिनट · प्रातः",
          desc: "उथल-पुथल से मौन तक पाँच चरण — श्वास, अभिव्यक्ति, 'हू' मंत्र, मौन और आनंद-उत्सव। महान मुक्ति।" },
        { id: "kundalini", title: "ओशो कुण्डलिनी ध्यान", tag: "60 मिनट · सूर्यास्त",
          desc: "दिन भर की थकान को कंपन से झाड़िए, आनंद में नृत्य कीजिए, फिर साक्षी में विश्राम। सूर्य ढलते समय सर्वोत्तम।" },
        { id: "chakra", title: "चक्र ऊर्जा संतुलन", tag: "75 मिनट · व्यक्तिगत व ऑनलाइन",
          desc: "सात ऊर्जा केंद्रों की निर्देशित यात्रा — सूक्ष्म शरीर को महसूस करना, ढीला करना और पुनः संरेखित करना।" },
        { id: "sound", title: "नाद उपचार यात्राएँ", tag: "60 मिनट · सामूहिक व निजी",
          desc: "सिंगिंग बाउल, गोंग और स्वर — वह कंपन जो शब्दों के पार की गाँठें खोलता है, गहरा विश्राम देता है।" },
        { id: "breathwork", title: "श्वास सत्र", tag: "60 मिनट · सभी स्तर",
          desc: "सजग जुड़ी हुई श्वास — दबी हुई भावनाओं की मुक्ति और शरीर की सहज जीवंतता में वापसी।" },
        { id: "whiterobe", title: "संध्या सत्संग व व्हाइट रोब", tag: "संध्या · समागम",
          desc: "संगीत, ओशो प्रवचन और साझा मौन — आश्रम का हृदय, हर सच्चे साधक के लिए खुला।" },
        { id: "nomind", title: "नो-माइंड और गिबरिश", tag: "7-दिवसीय गहन शिविर",
          desc: "ओशो की ध्यान-चिकित्सा: सब अर्थहीन बोलिए, जब तक केवल अर्थ न रह जाए। अत्यंत सरल, सरलतापूर्वक गहन।" },
        { id: "guidance", title: "एक-पर-एक आंतरिक मार्गदर्शन", tag: "निजी · ऑनलाइन",
          desc: "मा प्रेम महिमा के साथ निजी सत्र — सौम्य जिज्ञासा, ध्यान-नुस्खा, और आपके भीतर उठ रही हर बात के लिए आकाश।" },
      ],
    },
    stillness: {
      eyebrow: "साधना की एक झलक",
      h1: "एक मिनट ",
      h2: "केंद्रित होने का",
      sub: "एक और शब्द पढ़ने से पहले — मा प्रेम महिमा के सरलतम निर्देश के साथ बैठिए। साठ सेकंड। बस श्वास, और दो श्वासों के बीच का अंतराल।",
      phases: ["श्वास भरें", "धीरे रोकें", "छोड़ें", "अंतराल में विश्राम"],
      ready: "तैयार?",
      welcomeBack: "स्वागत है।",
      silenceNote: "मौन सदा यहीं था",
      seconds: "60 सेकंड",
      remain: "{n} सेकंड शेष",
      begin: "एक मिनट शुरू करें",
      breathing: "श्वास चल रही है…",
      sitAgain: "फिर बैठें",
    },
    testimonials: {
      eyebrow: "साधकों के अनुभव",
      h1: "जो बचता है ",
      h2: "बैठक के बाद",
      shareCta: "अपना अनुभव साझा करें",
      formTitle: "आपके शब्द किसी और का पथ प्रकाशित कर सकते हैं",
      namePh: "आपका नाम (जैसे A. Malik)",
      rolePh: "आपकी भूमिका (वैकल्पिक)",
      textPh: "ध्यान में आपके भीतर क्या बदला…",
      submitReflection: "अनुभव भेजें",
      reflectionSuccess: "धन्यवाद — मा प्रेम महिमा की स्वीकृति के बाद आपका अनुभव यहाँ दिखेगा।",
      reflectionError: "अभी भेजा नहीं जा सका — बाद में पुनः प्रयास करें।",
      quotes: [
        { text: "ओशो कुण्डलिनी ध्यान के बाद मेरी गहरी नींद मात्रा में दोगुनी हो गई और नींद की गुणवत्ता भी सुधरी। मैंने अपने स्लीप-ट्रैकर गैजेट से इसे मापा।", name: "A. Malik", role: "ध्यान सहभागी" },
        { text: "एक शब्द — जागरूकता — का अर्थ समझाकर मेरा जीवन सदा के लिए बदल दिया।", name: "L. Gunasinge", role: "ध्यान सहभागी" },
        { text: "सचमुच थोड़ी देर के लिए सोचना बंद हो गया। महज एक घंटे के ध्यान के बाद।", name: "J. Shih", role: "वकील · सत्र सहभागी" },
        { text: "मैंने कभी नहीं सोचा था कि किसी का मन विचारों के बिना हो सकता है — आज मैंने इसे महसूस किया।", name: "H. Panjavani", role: "ध्यान सहभागी" },
      ],
    },
    contact: {
      eyebrow: "आमंत्रण · संपर्क",
      h1: "यह मौन",
      h2: "अपनों तक पहुँचाइए",
      sub: "मा प्रेम महिमा शिविर संचालन, महोत्सव सत्र, कॉरपोरेट माइंडफुलनेस और निजी ऑनलाइन बैठकों के लिए उपलब्ध हैं। हर संदेश स्वयं पढ़ा जाता है।",
      invites: [
        { title: "वेलनेस शिविर व महोत्सव", desc: "विश्वभर में ओशो ध्यान और सत्संग समागमों का संचालन।" },
        { title: "कॉरपोरेट माइंडफुलनेस", desc: "आधुनिक बोझ ढोती टीमों के लिए सक्रिय ध्यान कार्यक्रम।" },
        { title: "ऑनलाइन निजी सत्र", desc: "एक-पर-एक मार्गदर्शन, आप पथ पर जहाँ भी हों।" },
      ],
      labels: { name: "पूरा नाम", email: "ईमेल", phone: "फ़ोन", eventDate: "कार्यक्रम की तिथि", address: "पूरा पता", type: "संदेश का प्रकार", location: "शहर / देश", message: "संदेश" },
      ph: { name: "आपका नाम", email: "you@email.com", phone: "जैसे +91 98XXX XXXXX", address: "स्थल, गली/मार्ग, शहर, देश…", location: "आप कहाँ हैं?", message: "अपने समागम, शिविर या भीतर उठ रही बात के बारे में बताइए…" },
      types: ["शिविर संचालन", "ऑनलाइन एक-पर-एक सत्र", "चक्र संतुलन", "नाद उपचार सत्र", "श्वास सत्र", "कॉरपोरेट कार्यशाला", "प्रेस / साक्षात्कार"],
      submit: "पवित्र संदेश भेजें",
      sending: "भेजा जा रहा है…",
      success: "आपका संदेश मिल गया। मा प्रेम महिमा का डेस्क शीघ्र उत्तर देगा।",
      error: "अभी भेजा नहीं जा सका — कृपया mahima.ca1@gmail.com पर ईमेल करें",
      phoneLabel: "फ़ोन",
    },
    footer: {
      quote: "\"यदि आपके भीतर कहीं धीमा होने, स्वयं को समझने, थोड़ा अधिक जीवंत और शांत महसूस करने की ललक है… तो यह स्थान आपके लिए है।\"",
    },
    events: {
      navLabel: "समागम",
      eyebrow: "आगामी समागम",
      h1: "आगे कहाँ ",
      h2: "मिलेंगी",
      sub: "शिविर, सत्संग और सत्र — व्यक्तिगत या ऑनलाइन जुड़िए।",
      empty: "नए समागम जल्द घोषित होंगे। जुड़े रहिए।",
      types: { Retreat: "शिविर", Satsang: "सत्संग", Workshop: "कार्यशाला", Online: "ऑनलाइन सत्र" },
      join: "जुड़ें / पंजीकरण",
    },
  },

  gu: {
    nav: {
      about: "પરિચય", meditations: "ધ્યાન", journey: "યાત્રા",
      gallery: "ગેલેરી", testimonials: "અનુભવો", contact: "સંપર્ક",
      invite: "માં પ્રેમ મહિમાને આમંત્રણ",
    },
    hero: {
      eyebrow: "ઓશો શિષ્યા · પ્રમાણિત ધ્યાન શિક્ષિકા · સહ-સ્થાપક, ઓશો યૂનિવર્સલ",
      lines: ["મૌન એટલે", "અવાજની ગેરહાજરી નહીં —", "તે તો હાજરી છે", "તમારી."],
      sub: "માં પ્રેમ મહિમા તમને અંતરમુખ થવા આમંત્રિત કરે છે — ઓશોના સક્રિય ધ્યાનો, સત્સંગ અને સંપૂર્ણ હાજર રહેવાની સરળ કળા દ્વારા.",
      ctaExplore: "ધ્યાન જુઓ",
      ctaInvite: "રિટ્રીટ માટે આમંત્રણ",
      badge: "પ્રમાણિત ઓશો ફેસિલિટેટર",
      breath: ["શ્વાસ અંદર", "રોકો", "શ્વાસ બહાર", "આરામ"],
    },
    marquee: [
      "ઓશો ડાયનામિક ધ્યાન", "કુંડલિની જાગરણ", "ચક્ર સંતુલન", "ધ્વનિ ઉપચાર",
      "શ્વાસ યાત્રાઓ", "નો-માઇંડ સાધના", "મૌન શિબિર", "હૃદય સત્સંગ",
    ],
    about: {
      eyebrow: "પરિચય · ઘોષણા",
      h1: "એક સાથી મુસાફર,",
      h2: "માસ્ટર નહીં.",
      quote: "\"મારી સાથે ચાલો… અનુયાયી તરીકે નહીં, પણ આ સુંદર આંતરિક માર્ગ પર સાથી મુસાફર તરીકે.\"",
      imgAlt: "માં પ્રેમ મહિમા — શાંત હાજરીમાં",
      chapters: [
        {
          n: "01", title: "તરસ અને મિલન",
          body: "માં પ્રેમ મહિમા જીવનથી ભાગવા ધ્યાન તરફ નહીં આવી — તે એટલે આવી કારણ કે અંતરમાં ધીમે થવાની, સમજવાની, ખરેખર જીવંત અનુભવવાની તડપ હતી. ઓશોના શબ્દો અને ધ્યાનોમાં તેને કોઈ સિદ્ધાંત નહીં, પણ અરીસો મળ્યો: પોતાની પાસે પાછા ફરવાનો માર્ગ.",
        },
        {
          n: "02", title: "તકનીકોની પાર મૌન",
          body: "ઓશોના સક્રિય ધ્યાનો — કંપન, ઉગાર, નૃત્ય — દ્વારા તેણે શોધ્યું કે મૌન બનાવવાથી આવતું નથી. જ્યારે શરીર પોતાનું સંચિત બધું વ્યક્ત કરી દે, ત્યારે મૌન પોતે જ ઊતરી આવે છે. આ એ શાંતિ છે જે તેણી હવે વહેંચે છે — જેને શબ્દો પૂરેપૂરાં કહી શકતા નથી.",
        },
        {
          n: "03", title: "ઓશો યૂનિવર્સલની સહ-સ્થાપના",
          body: "ઓશો યૂનિવર્સલના સહ-સ્થાપક તરીકે, મા પ્રેમ વિશ્વભરના સાધકો માટે જગ્યા ઊભી કરે છે — શિબિરો, સત્સંગ અને એકાંત માર્ગદર્શન. તેણી તમને અનુસરણ માગતી નથી. તેણી આ સુંદર આંતરિક માર્ગ પર સાથી મુસાફર બનીને સાથે ચાલવાનું આમંત્રણ આપે છે.",
        },
      ],
    },
    yatra: {
      eyebrow: "યાત્રા · એક તીર્થ",
      h1: "નકશા પર પાંચ નિશાન",
      h2: "એક જ જાગૃતિના",
      intro: "માં પ્રેમ મહિમા ઓશોના બાળપણના માર્ગે ચાલી — કુચવાડાના જન્મસ્થાનથી તે ઝાડ સુધી જેની નીચે તેઓ અસ્તિત્વમાં લીન થઈ ગયા. દરેક પડાવે પોતાની છાપ છોડી.",
      stopLabel: "પડાવ",
      stops: [
        {
          title: "કુચવાડા — જ્યાં તેઓ આવ્યા",
          body: "એટલું નાનું ગામ કે દુનિયા તેને લગભગ ભૂલી ગઈ — પણ અહીં જ રજનીશ ચંદ્ર મોહને પહેલો શ્વાસ લીધો. આ સાંકડી ગલીઓમાં ચાલતાં મા પ્રેમે અનુભવ્યું કે વિશાળ કેવી રીતે સાદગીમાં છુપાયેલું હોય છે.",
        },
        {
          title: "બાળપણનું ઘર",
          body: "આ ગુલાબી દરવાજા પાછળ, એક બાળકે સાંભળેલી દરેક વાત પર પ્રશ્ન ઉઠાવ્યો. તેની ઉંબરે ઊભા રહેતાં શિક્ષણ સરળ થઈ જાય છે: જાગૃતિ બીજે ક્યાંય મળતી નથી — તે તમારા પોતાના પહેલા ઘરથી, તમારા પોતાના પહેલા પ્રશ્નોથી શરૂ થાય છે.",
        },
        {
          title: "વર્ગખંડ",
          body: "લાકડાની બેંચો, જાળીદાર બારીઓ, અજ્વાળામાં ચોકનો ધૂળિયો. અહીં જુવાન ઓશોએ અથાગ વાંચન કર્યું અને દરેક શિક્ષક સાથે દલીલ કરી. તેમના ડેસ્ક પર બેસીને, મા પ્રેમ એ વિદ્યાર્થી સાથે બેઠી જે માસ્ટર પહેલાં હતો — તે જીદ્દી, તેજસ્વી જિજ્ઞાસા જે ક્યારેય છૂટી નહીં.",
        },
        {
          title: "ગાડરવાડાની શાળા",
          body: "આ પીળી દીવાલોની અંદર શિસ્ત, શરારત અને પ્રતિભાના વર્ષો વીત્યા. તે યાદ અપાવે છે કે સૌથી મોટા બંડનું શિક્ષણ પણ ક્યાંક થાય છે — અને દરેક સંસ્થાએ કોઈ એવા બાળકને સંભાળ્યો છે જેને તે અટકાવી શકી નહીં.",
        },
        {
          title: "મૌલશ્રી વૃક્ષ",
          body: "21 માર્ચ 1953. આ જ ઝાડ નીચે, એકવીસ વર્ષનો યુવક તે બની ગયો જે તે સદાથી હતો. મા પ્રેમે તેના થડને એવી રીતે ભેટ્યું જાણે જૂના મિત્રને મળી હોય — કારણ કે દરેક સાધક માટે આ ઇતિહાસ નથી, પણ નિમંત્રણ છે.",
        },
      ],
      close1: "\"યાત્રા ક્યારેય સ્થળો વિશે નહોતી.",
      close2: " સ્થળો તો બસ ઘર તરફ ઈશારો કરતાં હતાં.\"",
    },
    gallery: {
      eyebrow: "ઝલક",
      h1: "માર્ગ, ",
      h2: "ફ્રેમોમાં",
      intro: "ઓશોને ઘડનાર સ્થળોની યાત્રા — કુચવાડાનું જન્મસ્થાન, ગાડરવાડાની શાળા, અને મૌલશ્રી વૃક્ષ જ્યાં તેઓ જાગ્યા.",
      captions: [
        "માસ્ટરની હાજરીમાં",
        "ઓશો કક્ષ — તેમનો બાળપણનો અભ્યાસ કક્ષ",
        "મૌલશ્રી ઝાડ નીચે, જ્યાં ઓશો પ્રબોધ પામ્યા",
        "અંતરો પાર સત્સંગ",
        "કુચવાડાની ગલીઓ — ઓશોનું જન્મસ્થાન",
        "ઓશોના બાળપણના ઘરના દરવાજે",
        "તેમના વર્ગખંડમાં, જ્યાંથી બધું શરૂ થયું",
        "ગાડરવાડાની શાળા — ઓશો સ્માર્ટ ક્લાસ",
        "ઓશો વૃક્ષને ભેટીને",
      ],
    },
    offerings: {
      eyebrow: "ધ્યાન અને સત્રો",
      h1: "આધુનિક, બેચેન મન",
      h2: " માટે સાધનાઓ",
      filterTag: "બધાં સત્રો · રૂબરૂ અને ઓનલાઇન",
      cards: [
        { id: "dynamic", title: "ઓશો ડાયનામિક ધ્યાન", tag: "60 મિનિટ · સવાર",
          desc: "ઉથલપાથલથી મૌન સુધીના પાંચ તબક્કા — શ્વાસ, અભિવ્યક્તિ, 'હૂ' મંત્ર, મૌન અને આનંદ-ઉત્સવ. મહાન મુક્તિ." },
        { id: "kundalini", title: "ઓશો કુંડલિની ધ્યાન", tag: "60 મિનિટ · સૂર્યાસ્ત",
          desc: "દિવસની થાક કંપનથી ઝટકો, આનંદમાં નૃત્ય કરો, પછી સાક્ષીભાવમાં આરામ. સૂર્ય ઢળતી વખતે શ્રેષ્ઠ." },
        { id: "chakra", title: "ચક્ર ઊર્જા સંતુલન", tag: "75 મિનિટ · રૂબરૂ અને ઓનલાઇન",
          desc: "સાત ઊર્જા કેન્દ્રોની માર્ગદર્શિત યાત્રા — સૂક્ષ્મ શરીરને અનુભવવું, ઢીલું કરવું અને ફરી સંગત કરવું." },
        { id: "sound", title: "ધ્વનિ ઉપચાર યાત્રાઓ", tag: "60 મિનિટ · સામૂહિક અને ખાનગી",
          desc: "સિંગિંગ બાઉલ, ગોંગ અને સ્વર — એવું કંપન જે શબ્દોથી પરેની ગાંઠો ઢીલી કરે, ઊંડો આરામ આપે." },
        { id: "breathwork", title: "શ્વાસ સત્રો", tag: "60 મિનિટ · તમામ સ્તર",
          desc: "સજાગ જોડાયેલો શ્વાસ — દબાયેલી લાગણીઓની મુક્તિ અને શરીરની સહજ જીવંતતામાં વાપસી." },
        { id: "whiterobe", title: "સાંજ સત્સંગ અને વ્હાઇટ રોબ", tag: "સાંજ · સમાગમ",
          desc: "સંગીત, ઓશો પ્રવચન અને સામૂહિક મૌન — કમ્યુનનું હૃદય, દરેક સાચા સાધક માટે ખુલ્લું." },
        { id: "nomind", title: "નો-માઇંડ અને ગિબરિશ", tag: "7-દિવસીય ગાઢ શિબિર",
          desc: "ઓશોની ધ્યાન-ચિકિત્સા: બધું અર્થહીન બોલો, જ્યાં સુધી ફક્ત અર્થ ન રહી જાય. અત્યંત સરળ, સરળતાથી ઊંડું." },
        { id: "guidance", title: "એક-પર-એક આંતરિક માર્ગદર્શન", tag: "ખાનગી · ઓનલાઇન",
          desc: "માં પ્રેમ મહિમા સાથે ખાનગી સત્ર — કોમળ જિજ્ઞાસા, ધ્યાન-પ્રિસ્ક્રિપ્શન, અને તમારા અંતરમાં ઊગતી દરેક બાબત માટે જગ્યા." },
      ],
    },
    stillness: {
      eyebrow: "સાધનાની એક ઝલક",
      h1: "એક મિનિટ ",
      h2: "કેન્દ્રિત થવાની",
      sub: "બીજો એક શબ્દ વાંચો તે પહેલાં — મા પ્રેમના સૌથી સરળ નિર્દેશ સાથે બેસો. સાઠ સેકન્ડ. બસ શ્વાસ, અને બે શ્વાસ વચ્ચેનું અંતર.",
      phases: ["શ્વાસ લો", "ધીમે રોકો", "મૂકો", "અંતરાળમાં આરામ"],
      ready: "તૈયાર?",
      welcomeBack: "પાછા સ્વાગત છે.",
      silenceNote: "મૌન તો અહીં જ હતું",
      seconds: "60 સેકન્ડ",
      remain: "{n} સેકન્ડ બાકી",
      begin: "એક મિનિટ શરૂ કરો",
      breathing: "શ્વાસ ચાલુ છે…",
      sitAgain: "ફરી બેસો",
    },
    testimonials: {
      eyebrow: "સાધકોના અનુભવો",
      h1: "જે રહી જાય ",
      h2: "બેઠક પછી",
      shareCta: "તમારો અનુભવ શેર કરો",
      formTitle: "તમારા શબ્દો બીજાનો માર્ગ પ્રકાશી શકે",
      namePh: "તમારું નામ (દા.ત. A. Malik)",
      rolePh: "તમારી ભૂમિકા (વૈકલ્પિક)",
      textPh: "ધ્યાનમાં તમારા અંતરમાં શું બદલાયું…",
      submitReflection: "અનુભવ મોકલો",
      reflectionSuccess: "આભાર — માં પ્રેમ મહિમાની મંજૂરી પછી તમારો અનુભવ અહીં દેખાશે.",
      reflectionError: "હમણાં મોકલી શકાયો નથી — પછી ફરી પ્રયાસ કરો.",
      quotes: [
        { text: "ઓશો કુંડલિની ધ્યાન પછી મારી ઊંડી ઊંઘ માત્રામાં બમણી થઈ અને ઊંઘની ગુણવત્તા પણ સુધરી. મેં તેને મારા સ્લીપ-ટ્રેકર ગેજેટથી માપી.", name: "A. Malik", role: "ધ્યાન સહભાગી" },
        { text: "એક શબ્દ — જાગૃતિ — નો અર્થ સમજાવીને મારું જીવન સદા માટે બદલી નાખ્યું.", name: "L. Gunasinge", role: "ધ્યાન સહભાગી" },
        { text: "ખરેખર થોડી વાર માટે વિચારવું બંધ થઈ ગયું. માત્ર એક કલાકના ધ્યાન પછી.", name: "J. Shih", role: "વકીલ · સત્ર સહભાગી" },
        { text: "મેં ક્યારેય વિચાર્યું નહોતું કે કોઈનું મન વિચારો વગર હોઈ શકે — આજે મેં તે અનુભવ્યું.", name: "H. Panjavani", role: "ધ્યાન સહભાગી" },
      ],
    },
    contact: {
      eyebrow: "આમંત્રણ · સંપર્ક",
      h1: "આ મૌન",
      h2: "તમારા લોકો સુધી પહોંચાડો",
      sub: "માં પ્રેમ મહિમા શિબિર સંચાલન, મહોત્સવ સત્રો, કોર્પોરેટ માઇન્ડફુલનેસ અને ખાનગી ઓનલાઇન બેઠકો માટે ઉપલબ્ધ છે. દરેક સંદેશ ખાસ વાંચવામાં આવે છે.",
      invites: [
        { title: "વેલનેસ શિબિરો અને મહોત્સવો", desc: "વિશ્વભરમાં ઓશો ધ્યાન અને સત્સંગ સમાગમોનું સંચાલન." },
        { title: "કોર્પોરેટ માઇન્ડફુલનેસ", desc: "આધુનિક ભાર ઢોતી ટીમો માટે સક્રિય ધ્યાન કાર્યક્રમો." },
        { title: "ઓનલાઇન ખાનગી સત્રો", desc: "એક-પર-એક માર્ગદર્શન, તમે માર્ગ પર જ્યાં પણ હો." },
      ],
      labels: { name: "પૂરું નામ", email: "ઈમેલ", phone: "ફોન", eventDate: "કાર્યક્રમની તારીખ", address: "પૂરું સરનામું", type: "સંદેશનો પ્રકાર", location: "શહેર / દેશ", message: "સંદેશ" },
      ph: { name: "તમારું નામ", email: "you@email.com", phone: "દા.ત. +91 98XXX XXXXX", address: "સ્થળ, શેરી, શહેર, દેશ…", location: "તમે ક્યાં છો?", message: "તમારા સમાગમ, શિબિર કે અંતરમાં ઊગતી વાત વિશે લખો…" },
      types: ["શિબિર સંચાલન", "ઓનલાઇન એક-પર-એક સત્ર", "ચક્ર સંતુલન", "ધ્વનિ ઉપચાર સત્ર", "શ્વાસ સત્ર", "કોર્પોરેટ વર્કશોપ", "પ્રેસ / ઈન્ટરવ્યૂ"],
      submit: "પવિત્ર સંદેશ મોકલો",
      sending: "મોકલાય છે…",
      success: "તમારો સંદેશ મળી ગયો. મા પ્રેમનું ડેસ્ક જલ્દી જવાબ આપશે.",
      error: "હમણાં મોકલી શકાયો નથી — કૃપા કરી mahima.ca1@gmail.com પર ઈમેલ કરો",
      phoneLabel: "ફોન",
    },
    footer: {
      quote: "\"જો તમારા અંતરમાં ક્યાંક ધીમે થવાની, પોતાને સમજવાની, થોડું વધુ જીવંત અને શાંત અનુભવવાની તડપ છે… તો આ સ્થળ તમારા માટે છે.\"",
    },
    events: {
      navLabel: "સમાગમ",
      eyebrow: "આગામી સમાગમો",
      h1: "આગળ ક્યાં ",
      h2: "મળશે",
      sub: "શિબિરો, સત્સંગ અને સત્રો — રૂબરૂ કે ઓનલાઇન જોડાઓ.",
      empty: "નવા સમાગમો જલ્દી જાહેર થશે. જોડાયેલા રહો.",
      types: { Retreat: "શિબિર", Satsang: "સત્સંગ", Workshop: "વર્કશોપ", Online: "ઓનલાઇન સત્ર" },
      join: "જોડાઓ / નોંધણી",
    },
  },
};
